import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        url_base: process.env.VUE_APP_URL + '/api/',
        url_modulo: process.env.VUE_APP_URL,
        token: localStorage.getItem("token_yakusela") || null,
        rol: localStorage.getItem("rol_yakusela") || "",
        token_id: localStorage.getItem("token_id_yakusela") || null,
        usuario: {
            "funcionario": {}
        },
        sistemas: {}
    },
    getters: {
        isLogin(state) {
            return state.token !== null;
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token === null ? null : token.access_token;
            state.token_id = token === null ? null : token.token_id;
        },
        setUsuario(state, usuario) {
            state.usuario = usuario;
        },
        setRol(state, rol) {
            state.rol = rol;
        },
        setSistemas(state, sistemas) {
            state.sistemas = sistemas;
        },
    },
    actions: {
        getUsuario({commit}) {
            axios.get(this.state.url_base + 'user')
                .then(response => {
                    commit('setUsuario', response.data)
                }).catch(e => {
                commit('setUsuario', {});
            });
        },
        getSistemas({commit}) {
            axios.get(this.state.url_base + 'sistemas')
                .then(response => {
                    commit('setSistemas', response.data)
                }).catch(e => {
                commit('setSistemas', {});
            });
        },
        getToken(context, credencials) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'POST',
                    url: context.state.url_base + "autenticar",
                    data: credencials
                }).then(response => {
                    if (response.data.res && !response.data.cambiarPassword) {
                        const token = response.data.token;
                        localStorage.setItem("token_yakusela", token.access_token);
                        localStorage.setItem("token_id_yakusela", token.token_id);
                        localStorage.setItem("rol_yakusela", response.data.usuario.rol);
                        context.commit("setToken", token);
                        context.commit("setRol", response.data.usuario.rol);
                        context.commit("setUsuario", response.data.usuario);
                        context.commit("setSistemas", response.data.sistemas);
                        //header de axios
                        axios.defaults.headers.common.Authorization = "Bearer " + token;
                    }
                    resolve(response);
                }).catch(e => {
                    reject(e);
                })
            });
        },
        destroyToken(context) {
            if (context.getters.isLogin) {
                axios.defaults.headers.common.Authorization = "Bearer " +  context.state.token;
                return new Promise((resolve, reject) => {
                    axios({
                        method: 'POST',
                        url: context.state.url_base + "logout",
                    }).then(response => {
                        localStorage.removeItem("token_yakusela");
                        localStorage.removeItem("token_id_yakusela");
                        localStorage.removeItem("rol_yakusela");
                        context.commit("setToken", null);
                        context.commit("setRol", "");
                        context.commit("setUsuario", {});
                        context.commit("setSistemas", {});
                        resolve(response);
                    }).catch(e => {
                        localStorage.removeItem("token_yakusela");
                        localStorage.removeItem("token_id_yakusela");
                        localStorage.removeItem("rol_yakusela");
                        context.commit("setToken", null);
                        context.commit("setRol", "");
                        context.commit("setUsuario", {});
                        context.commit("setSistemas", {});
                        reject(e);
                    })
                });
            }
        },
    },
    modules: {}
})
